import React, { createContext, useEffect, useReducer } from 'react'
import jwtDecode from 'jwt-decode'
import axios from 'axios.js'
import { MatxLoading } from 'app/components'

const initialState = {
    isAuthenticated: false,
    isInitialised: false,
    user: null,
    selectedSystem: null,
    systems: null,
}

const isValidToken = (accessToken) => {
    if (!accessToken) {
        return false
    }

    const decodedToken = jwtDecode(accessToken)
    const currentTime = Date.now() / 1000
    return decodedToken.exp > currentTime
}

const setSession = (accessToken) => {
    if (accessToken) {
        console.log(document.cookie)

        sessionStorage.setItem('accessToken', accessToken)
        axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`
    } else {
        sessionStorage.removeItem('accessToken')
        delete axios.defaults.headers.common.Authorization
    }
}

const reducer = (state, action) => {
    switch (action.type) {
        case 'INIT': {
            const { isAuthenticated, user } = action.payload
            let defSys = null;
            if(user && user.systems)
            for(let s of user.systems){
                if(s.role === 'admin'){
                    defSys = s;
                    break;
                }
            }
            console.log(defSys);
            return {
                ...state,
                isAuthenticated,
                isInitialised: true,
                user,
                systems: user?user.systems:null,
                selectedSystem: defSys,
            }
        }
        case 'USER': {
            const { user } = action.payload
            let defSys = null;
            for(let s of user.systems){
                if(s.role === 'admin'){
                    defSys = s;
                    break;
                }
            }
            console.log("Selected System");
            console.log(defSys);
            return {
                ...state,
                isAuthenticated: true,
                isInitialised: true,
                user,
                systems: user.systems,
                selectedSystem: defSys,
            }
        }
        case 'LOGIN': {
            const { non } = action.payload

            return {
                ...state,
                isAuthenticated: true,

            }
        }
        case 'LOGOUT': {
            return {
                ...state,
                isAuthenticated: false,
                user: null,
            }
        }
        case 'REGISTER': {
            const { user } = action.payload

            return {
                ...state,
                isAuthenticated: true,
                user,
            }
        }
        case 'SELECTD_SYSTEM': {
            const {selectedSystem} = action.payload
            return {
                ...state,
                selectedSystem: selectedSystem,
            }
        }
        default: {
            return { ...state }
        }
    }
}

const AuthContext = createContext({
    ...initialState,
    method: 'JWT',
    login: () => Promise.resolve(),
    logout: () => { },
    register: () => Promise.resolve(),

})

export const AuthProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState)


    const login = async (email, password) => {
        const response = await axios.post('/api/login', {
            username: email,
            password: password,
        })
        console.log(response.headers)
        if ('access_token' in response.data) {
            const accessToken = response.data.access_token

            try {
                setSession(accessToken)
            } catch (error) {
                console.error(error)

            }

            dispatch({
                type: 'LOGIN',
                payload: {

                },
            })
        } else {
            throw new Error("ไม่สามารถเข้าสู่ระบบได้")
        }
    }

    const setSelecctedSystem = (system) =>{
        state.systems.forEach(el => {
            if(el.role === 'admin' && el.system_id === system.system_id){
                dispatch({
                    type: 'SELECTD_SYSTEM',
                    payload: {
                        selectedSystem: system,
                    },
                })
            }
        });
    }

    const profile = async () => {

        const userResponse = await axios.get('/api/users/me/', { withCredentials: true })

        const user = userResponse.data.data
        const systems = user.systems
        let is_valid = false;
        for (let i = 0; i < systems.length; i++) {
            const sys = systems[i]
            if (sys.active === 'True' && sys.role === 'admin') {
                is_valid = true
            }
        }
        if (is_valid) {
            console.log(user)
            dispatch({
                type: 'USER',
                payload: {
                    user,
                },
            })
        } else {
            throw new Error("ไม่พบผู้ใช้งานในระบบ")
        }
    }

    const logout = () => {
        setSession(null)
        dispatch({ type: 'LOGOUT' })
    }


    useEffect(() => {
        ; (async () => {

            try {
                const accessToken = window.sessionStorage.getItem('accessToken')
                //console.log("TOKEN:"+accessToken)
                if (accessToken && isValidToken(accessToken)) {
                    setSession(accessToken)
                    const response = await axios.get('/api/users/me/')
                    const user = response.data.data
                    const systems = user.systems

                    let is_valid = false;
                    for (let i = 0; i < systems.length; i++) {
                        const sys = systems[i]
                        if (sys.active === 'True' && sys.role === 'admin') {
                            is_valid = true
                        }
                    }
                    if (is_valid) {
                        dispatch({
                            type: 'INIT',
                            payload: {
                                isAuthenticated: true,
                                user,
                            },
                        })
                    } else {
                        dispatch({
                            type: 'INIT',
                            payload: {
                                isAuthenticated: false,
                                user: null,
                            },
                        })
                    }
                } else {
                    dispatch({
                        type: 'INIT',
                        payload: {
                            isAuthenticated: false,
                            user: null,
                        },
                    })
                }
            } catch (err) {
                //console.error(err)
                dispatch({
                    type: 'INIT',
                    payload: {
                        isAuthenticated: false,
                        user: null,
                    },
                })
            }
        })()
    }, [])

    if (!state.isInitialised) {
        return <MatxLoading />
    }

    return (
        <AuthContext.Provider
            value={{
                ...state,
                method: 'JWT',
                profile,
                login,
                logout,
                setSelecctedSystem,
            }}
        >
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext
